"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../http");
var common_class_1 = require("../http/common_class");
exports.chatsApiPaths = {
    block: 'v1/chats/block/',
    chats: 'v1/chats/',
    delete: 'v1/chats/delete/',
    offer: 'v1/chats/offer/',
    agent: 'v1/get-agent-chat/',
    readMessages: 'v1/chats/read/',
    unblock: 'v1/chats/unblock/',
    moveToSpam: 'v1/chats/move-to-spam-desktop/',
    removeFromSpam: 'v1/chats/remove-from-spam-desktop/',
    getSpamList: 'v1/get-spam-chats-desktop/',
    moveToArchive: 'v1/chats/move-to-archive-desktop/',
    removeFromArchive: 'v1/remove-from-archive-desktop/',
    getArchivedList: 'v1/chats/get-archived-chats-desktop/',
};
var ChatsHttp = /** @class */ (function (_super) {
    __extends(ChatsHttp, _super);
    function ChatsHttp(config) {
        var _this = _super.call(this, config) || this;
        _this.getOffer =
            http_1.createHttpGetFunction("" + _this.baseAPIPath + exports.chatsApiPaths.offer)(_this.client);
        _this.getAgent = http_1.createHttpGetFunction("" + _this.baseAPIPath + exports.chatsApiPaths.agent)(_this.client);
        _this.getChats =
            http_1.createHttpGetFunction("" + _this.baseAPIPath + exports.chatsApiPaths.chats)(_this.client);
        _this.block = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.chats)(_this.client);
        _this.unblock = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.chats)(_this.client);
        _this.delete = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.chats)(_this.client);
        _this.postRead = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.readMessages)(_this.client);
        // Методы для работы со спамом
        _this.moveToSpam = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.moveToSpam)(_this.client);
        _this.removeFromSpam = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.removeFromSpam)(_this.client);
        _this.getSpamList = http_1.createHttpGetFunction("" + _this.baseAPIPath + exports.chatsApiPaths.getSpamList)(_this.client);
        // Методы для работы с архивом
        _this.moveToArchive = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.moveToArchive)(_this.client);
        _this.removeFromArchive = http_1.createHttpPostFunction("" + _this.baseAPIPath + exports.chatsApiPaths.removeFromArchive)(_this.client);
        _this.getArchivedList = http_1.createHttpGetFunction("" + _this.baseAPIPath + exports.chatsApiPaths.getArchivedList)(_this.client);
        return _this;
    }
    ChatsHttp.prototype.blockChat = function (body) {
        return this.block(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.unblockChat = function (body) {
        return this.block(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.deleteChat = function (body) {
        return this.delete(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.getAgentChat = function (agentId) {
        var body = { agentId: agentId };
        return this.getAgent(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.getOfferChat = function (offerId) {
        var body = { offerId: offerId };
        return this.getOffer(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.getChatsList = function (body) {
        return this.getChats(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.markAllMessagesAsRead = function (body) {
        return this.postRead(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.moveToSpamChat = function (body) {
        return this.moveToSpam(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.removeFromSpamChat = function (body) {
        return this.removeFromSpam(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.getSpamListChats = function (body) {
        return this.getSpamList(__assign({ body: body }, this.baseUri, { logger: this.logger }));
    };
    ChatsHttp.prototype.moveToArchiveChat = function (body) {
        return this.moveToArchive(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.removeFromArchiveChat = function (body) {
        return this.removeFromArchive(__assign({ body: body }, this.baseUri));
    };
    ChatsHttp.prototype.getArchivedListChats = function (body) {
        return this.getArchivedList(__assign({ body: body }, this.baseUri, { logger: this.logger }));
    };
    return ChatsHttp;
}(common_class_1.CommonHttpClass));
exports.ChatsHttp = ChatsHttp;
//# sourceMappingURL=index.js.map